import { makeStyles } from "@material-ui/core";
import MaterialTable, { MTableToolbar } from "material-table";
import { observer } from "mobx-react-lite";
import React, { createRef } from "react";
import { useEffect, useState } from "react";
import { Header } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import UserRoleForm from '../../features/roles/form/UserRoleForm';
import PaginatedTable from "../../app/common/table/PaginatedTable";
import StyledHeader from "../../app/common/styled-element/StyledHeader"
import styled from "styled-components";
import { User } from "../../app/models/user";
import { set } from "mobx";

const StyledContainer = styled.div`
        padding: 1em 2em;
`;

const useStyles = makeStyles({
    toolbarWrapper: {
        '& .MuiToolbar-gutters': {
            paddingLeft: 0,
            paddingRight: 0,
            width: '100%'
        },
        '& .MuiToolbar-gutters .MuiTextField-root': {
            width: '100%'
        },
        '& .MuiToolbar-gutters >:not(.MuiTextField-root)': {
            display: 'none'
        },
    },
});

const UserList = () => {
    const { userStore } = useStore();
    const { users, total, setPageNumber, pageNumber, isLoading, setSearchQuery, filterUsers, getUsersRole, filterValues } = userStore;

    const [modalState, setmodalState] = useState(false);
    const [user, setUser] = useState({
        id: '',
        name: '',
        roleIds: ['']
    });

    const [defaultRoles, setDefaultRoles] = useState([""])

    const getUser = async (userId: string) => {
        await getUsersRole(userId).then(user => {
            if (user) {
                let defaultRole = user.roles
                    .filter(r => r.isDefault === true)
                    .map(m => m.id);

                setDefaultRoles(defaultRole);

                setUser({
                    id: user.id,
                    name: user.name,
                    roleIds: user.roles.map(m => m.id)
                });
            }
        });
    }

    useEffect(() => {
        filterValues.pageNumber = 1;
        filterValues.searchKeyword = '';
        filterUsers();
    }, [filterUsers]);

    return (
        <>
            <StyledContainer>
                <StyledHeader content="User's Role" />
                <PaginatedTable<User>
                    columns={[
                        { title: 'Role', field: 'id', hidden: true },
                        { title: 'Employee', field: 'name' },
                        { title: 'Role', field: 'roles' },

                    ]}
                    actions={[
                        rowData => ({
                            icon: 'edit',
                            tooltip: 'Edit Role',
                            onClick: async (event) => {
                                await getUser(rowData.id);
                                setmodalState(true);
                            }
                        }),
                    ]}
                    total={total}
                    pageSize={10}
                    pageNumber={pageNumber}
                    totalCount={total ?? 0}
                    sorting={false}
                    draggable={false}
                    onChangePage={p => {
                        setPageNumber(p);
                    }}
                    onSearchChange={query => {
                        setSearchQuery(query);

                    }}
                    data={users}
                    isLoading={isLoading}
                    toolbar={true}
                    search={true}
                />
            </StyledContainer>
            <UserRoleForm open={modalState} setOpen={setmodalState} user={user} setUser={setUser} defaultRoles={defaultRoles} />
        </>
    )
}

export default observer(UserList);
